<template>
  <v-dialog max-width="40.0rem" v-model="open">
    <div class="image-upload-box-wrapper">
      <div class="image-upload-box">
        <div class="title-header">
          {{ headerTitle }}
          <span style="position: absolute; top: .5rem; right: .5rem"
            ><v-icon @click="open = false">close</v-icon></span
          >
        </div>
        <div class="main-content">
          <div class="image-wrapper">
            <img class="image" :src="changeImgSrc" />
          </div>
          <div v-if="changeButton" class="row action-buttons">
            <div v-if="hasExistingImage" class="col-6">
              <button @click="deleteImage" class="btn btn-close">
                Delete Photo
              </button>
            </div>
            <div v-else class="col-3"></div>
            <div class="col-6">
              <form enctype="multipart/form-data" novalidate>
                <div class="row profile-picture">
                  <div class="photo">
                    <div class="btn btn-back">Change Photo</div>
                  </div>
                </div>
                <div class="profile-picture-upload">
                  <input
                    class="input-file"
                    type="file"
                    id="file"
                    ref="file"
                    accept="image/*"
                    @change="
                      changePhoto($event.target.name, $event.target.files)
                    "
                  />
                </div>
              </form>
            </div>
          </div>
          <div v-else class="row action-buttons">
            <div class="col-6" style="text-align: left">
              <div class="btn btn-close" @click="resetPrevious">Cancel</div>
            </div>
            <div class="col-6" style="text-align: right">
              <div @click="saveImage" class="btn btn-save-new">Save Photo</div>
            </div>
          </div>
          <div style="color: var(--button-delete-color)" v-if="warning">
            {{errormessage}}
          </div>
        </div>
      </div>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right:1.0rem"
          ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
      <!--<v-btn flat :ripple="ripple" @click="snackbar = false">-->
      <!--<v-icon>close</v-icon>-->
      <!--</v-btn>-->
    </v-snackbar>
  </v-dialog>
</template>

<script>
import { IsEmptyObject } from "../../globalFunctions";
export default {
  name: "change-image",
  props: {
    image: String,
    company: Boolean
  },
  data: function() {
    return {
      open: true,
      src: null,
      changeButton: true,
      changeImgSrc: null,
      imageFile: null,
      warning: false,
      s3key: "",
      change: 0,
      bgColor: "#454545",
      timeOut: 1000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
      existingImage: {},
      hasExistingImage: false,
      headerTitle: this.company ? "Change Company Logo" : "Change Image",
      timeout: null,
      errormessage:""
    };
  },
  methods: {
    changePhoto(fieldName, fileList) {
      if (fileList[0].size / 1024 / 1024 >= 5) {
        this.errormessage="Image size can not be more than 5 MB"
        this.warning = true;
        this.imageFile = null;
      }else if(!(fileList[0].type.toLowerCase().includes("png")||fileList[0].type.toLowerCase().includes("jpg")||fileList[0].type.toLowerCase().includes("jpeg"))){
        this.errormessage="Only png and jpg file are acceptable"
        this.warning = true;
        this.imageFile = null;
      } 
      else {
        this.warning = false;
        this.changeImgSrc = URL.createObjectURL(fileList[0]);
        this.imageFile = fileList[0];
        this.changeButton = false;
      }
    },
    resetPrevious() {
      this.changeImgSrc = this.src;
      this.changeButton = true;
    },
    getImage() {
      const self = this;
      let token = JSON.parse(localStorage.getItem("token"));
      self
        .$http({
          method: self.$constants.METHOD.GET,
          url: self.$constants.BASE_URL.IMAGE,
          headers: {
            Authorization: "Bearer " + token
          }
        })
        .then(function(response) {
          if (response.status === 200) {
            if (!IsEmptyObject(response.data)) {
              self.existingImage = response.data;
              self.hasExistingImage = true;
            } else {
              self.hasExistingImage = false;
            }
          }
        })
        .catch(function() {
          self.existingImage = {};
        });
    },
    saveImage() {
      const self = this;
      let formData = new FormData();
      let token = JSON.parse(localStorage.getItem("token"));
      formData.append("file", this.imageFile);
      if (!IsEmptyObject(self.existingImage)) {
        formData.append("attrib_id", self.existingImage.attrib_id);
        formData.append("download_key", self.existingImage.download_key);
        formData.append("view_key", self.existingImage.view_key);
      }
      self.$http
        .post(self.$constants.BASE_URL.IMAGE, formData, {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          if (response.status === 200) {
            self.snackbar = true;
            self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
            self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
            self.snackMessage = self.$constants.ERROR_MESSAGES.UPDATED;
            self.timeout = setTimeout(function() {
              self.open = false;
              self.$emit("update-picture");
            }, 1500);
          }
        })
        .catch(function(error) {
          self.snackbar = error.response.description;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = error.message;
          self.timeout = setTimeout(function() {
            self.open = false;
            self.$emit("update-picture");
          }, 1500);
        });
    },
    deleteImage() {
      const self = this;
      let token = JSON.parse(localStorage.getItem("token"));
      let data = JSON.stringify({
        download_key: self.existingImage.download_key,
        view_key: self.existingImage.view_key,
        attrib_id: self.existingImage.attrib_id
      });
      self
        .$http({
          method: self.$constants.METHOD.DELETE,
          url: self.$constants.BASE_URL.IMAGE,
          headers: {
            Authorization: "Bearer " + token
          },
          data: data
        })
        .then(function(response) {
          if (response.status === 200) {
            self.snackbar = true;
            self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
            self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
            self.snackMessage = self.$constants.ERROR_MESSAGES.UPDATED;
            self.timeout = setTimeout(function() {
              self.open = false;
              self.$emit("update-picture");
            }, 1500);
          }
        })
        .catch(function(error) {
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = error.message;
          self.timeout = setTimeout(function() {
            self.open = false;
            self.$emit("update-picture");
          }, 1500);
        });
    }
  },
  beforeDestroy(){
    clearTimeout(this.timeout)
  },
  mounted() {
    const self = this;
    if (self.image) {
      self.src = self.image;
      self.changeImgSrc = self.src;
    }
    self.getImage();
  }
};
</script>

<style scoped>
.image-upload-box-wrapper {
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;
}
.image-upload-box {
}
.title-header {
  position: relative;
  text-align: left;
  font-size: 1.6rem;
  padding: 1rem;
}
.main-content {
}
.image-wrapper {
  padding: 2rem;
  background-color: #000000;
}
.image {
  width: 15rem;
  height: auto;
  /*border: .1rem dashed #cccccc;*/
}
.action-buttons {
  padding: 2rem 0 2rem 0;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 93%;
  height: 3.6rem;
  margin: 0 0.8rem 0 0.8rem;
  padding: 1.5rem 1.5rem 1.5rem 2rem;
  cursor: pointer;
}
.profile-picture {
  position: relative;
  margin: 0 0.8rem !important;
}
.profile-picture-upload {
  position: absolute;
  top: 0;
  left: 1.5rem;
  max-width: 75%;
  margin: 0.6rem 0.8rem;
  cursor: pointer;
}
#file {
  cursor: pointer;
}
.btn-back {
  padding: 0.5rem 1.5rem;
}
</style>
